import { Building } from '@/reducers/types'

export const MAX_LOCKERS = 5

export interface OtherFormData {
  apartmentsId: string
  luxerIds: string[]
  parcelPendingAvailable: boolean
}

export const getLockers = (building: Building) =>
  (building.luxerOneLocations ?? []) as Array<{ id: number; luxerOneId?: number | string }>

export const getOtherDefaults = (building: Building): OtherFormData => ({
  apartmentsId: String(building.apartmentsId ?? ''),
  luxerIds: getLockers(building).map((locker) => String(locker.luxerOneId)),
  parcelPendingAvailable: !!building.parcelPendingAvailable,
})
